import { fetchWrapper, handleResponse, buildOpts, hcUrl } from '../helpers';

const getCheckoutMeals = async ({ params }) => {
  const { menuSlug } = params;

  const response = await fetchWrapper(
    hcUrl(`/user_incentives/checkout_meals/${menuSlug}`),
    buildOpts()
  );
  return handleResponse(response);
};

export { getCheckoutMeals };
